import './styles.scss';
import React from 'react';
import {ArrowRightOutlined, LinkOutlined} from "@ant-design/icons";

interface Props {
    text: string,
    link: string,
    external?: boolean,
}

function Link({text, link, external}: Props) {

    if (external) {
        return (
            <a href={link} className='external-link' target="_blank" rel="noreferrer">
                <LinkOutlined style={{marginRight:6}}/>
                <div className='text'>{text}</div>
            </a>
        )
    }

    return (
        <div className='external-link'>
            <div className='text'>{text}</div>
            <ArrowRightOutlined style={{marginLeft:6}}/>
        </div>
    )
}

export default Link;